import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function PaxusdIcon({
  width = 50,
  height = 50,
  fill = 'white',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill={fill}
      {...props}
    >
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={8}
        y={12}
        width={19}
        height={15}
      >
        <path d="M8.465 12.9h18.47v13.38H8.465V12.9z" fill="#fff" />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.849 12.9c1.976 2.994 1.225 5.8-1.995 7.253-1.888.852-3.52 2.048-5.03 3.439-.053.05-.112.094-.162.147-3.29 3.544-6.481 3.303-10.197-.231l.116-.13c1.09-.195 2.178.027 3.265.05 3.43.07 6.274-1.186 8.677-3.564 2.03-1.62 3.433-3.714 4.576-6.013.177-.357.183-.887.75-.95z"
          fill="#0095D9"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.463 23.508c-.993-.246-1.997-.447-2.924-.913-1.973-.993-2.853-2.718-2.439-4.893.116-.607.26-1.224.5-1.79.817-1.93 1.307-3.94 1.725-5.987.744-3.64 1.692-4.406 5.384-4.63.145-.01.289-.045.433-.068.402-.176.807-.371 1.127.134-.022.07-.05.17-.104.18-2.106.332-2.993 2.07-3.98 3.595-1.838 2.838-2.74 5.933-2.067 9.35.092.467.234.917.502 1.316.488 1.293 1.421 2.353 1.92 3.642l-.077.064z"
        fill="#B2D134"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.246 5.426c-.33-.279-.738-.125-1.105-.199 1.708-1.63 3.6-2.062 5.445-.888 2.092 1.33 4.35 1.936 6.744 2.322 2.465.398 3.182 1.404 2.994 3.914-.051.69-.144 1.373-.51 1.984-.682-.088-.858-.724-1.22-1.146-1.586-1.85-3.41-3.339-5.821-3.975-.267-.075-.524-.176-.782-.275-1.487-.689-3.07-1.033-4.668-1.33-.377-.07-.81-.032-1.077-.407z"
        fill="#EBE710"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.783 7.214c2.5.487 4.24 2.127 5.885 3.899.417.449.765.962 1.145 1.446l.034.342c-1.092 2.345-2.355 4.578-4.239 6.396-.253.244-.433.597-.84.647-.258-.753.378-1.203.623-1.777 1.347-3.152 1.286-6.16-.817-8.993-.31-.417-.708-.728-1.104-1.052-.295-.243-.716-.412-.687-.908z"
        fill="#00845D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.784 7.214c4.692 2.958 4.606 8.905 2.14 12.326-.081.113-.104.268-.154.404-2.02 2.243-4.544 3.503-7.542 3.736-1.563.12-3.138.1-4.688-.236-.998-.956-1.473-2.22-2.036-3.434-1.121-3.504-.623-6.776 1.79-9.542 2.576-2.952 5.793-4.484 9.837-3.478l.653.224z"
        fill="#005120"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.128 6.99c-3.537-.36-6.636.553-9.168 3.138-2.427 2.477-2.996 5.496-2.59 8.804L6.5 20.01c-1.219-1.64-1.026-3.545-.776-5.348.438-3.146 2.009-5.799 4.061-8.197.682-.797 1.442-1.16 2.46-1.038 2.041.217 4.052.55 5.882 1.563z"
        fill="#4CB748"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.56 15.155c0 3.472-2.647 6.123-6.097 6.104-3.419-.018-6.225-2.826-6.201-6.205.024-3.507 3.116-6.55 6.63-6.526 3.315.022 5.667 2.771 5.667 6.627z"
        fill="#FEFEFE"
      />
    </svg>
  );
}

const MemoPaxusdIcon = React.memo(PaxusdIcon);
export default MemoPaxusdIcon;
